// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { convertToEpiQuote as createQuote, RequestQuote } from "@bg/App/Services/CustomQuoteService";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";

interface Props {
    apiParameter: RequestQuote;
    apiResult: { successful: boolean; error?: any };
}

type Parameter = RequestQuote & {
    onSuccess?: () => void;
    onComplete?: (result: any) => void;
    onError?: (e: any) => void;
};

type HandlerType = Handler<Parameter, Props>;

export const BeginLoadingquotes: HandlerType = props => {
    props.dispatch({
        type: "Pages/MyCustomQuotes/BeginRequestQuote",
    } as any);
};

export const DispatchBeginAction: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const CallApiWithParameters: HandlerType = async props => {
    props.apiResult = await createQuote(props.apiParameter);
};

export const OnError: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.dispatch({
            type: "Pages/MyCustomQuotes/CompleteRequestingQuote",
        } as any);
        props.parameter.onError?.(props.apiResult.error);
    }
};

export const RedirectOnComplete: HandlerType = props => {
    if (props.apiResult.successful) {
        props.dispatch({
            type: "Pages/MyCustomQuotes/CompleteRequestingQuote",
        } as any);
        const requestQuotePageUrl = getPageLinkByPageType(props.getState(), "RfqRequestQuotePage")?.url;
        if (requestQuotePageUrl) {
            window.location.href = requestQuotePageUrl;
        }
    }
};

export const chain = [BeginLoadingquotes, DispatchBeginAction, CallApiWithParameters, OnError, RedirectOnComplete];

const convertToQuote = createHandlerChainRunner(chain, "ConvertToQuote");
export default convertToQuote;
